import { render } from "./CameraTransform.vue?vue&type=template&id=32240172&ts=true"
import script from "./CameraTransform.vue?vue&type=script&lang=ts"
export * from "./CameraTransform.vue?vue&type=script&lang=ts"

import "./CameraTransform.vue?vue&type=style&index=0&id=32240172&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__